// This file was automatically generated from appchart.reportFeeds.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.reportFeeds');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.reportFeeds.feed = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ol id="', soy.$$escapeHtml(opt_data.listId), '"></ol><div class="moreFeedContainer"><button id="', soy.$$escapeHtml(opt_data.buttonId), '" class="el8button moreFeed">More</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.reportFeeds.feedItemContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="feedItemContent">', opt_data.content, opt_data.buttons, '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.reportFeeds.qtipLabResult = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="labResultHoverValue">Value: ', soy.$$escapeHtml(opt_data.value), '</span><br>Reference Range: ', soy.$$escapeHtml(opt_data.refRange), (opt_data.abnormalFlag) ? '<br>Abnormal Value: ' + ((opt_data.abnormalDescription) ? soy.$$escapeHtml(opt_data.abnormalDescription) + ' ' : '') + '[' + soy.$$escapeHtml(opt_data.abnormalFlag) + ']' : '', (opt_data.labFacilityName) ? '<br>Loc: ' + soy.$$escapeHtml(opt_data.labFacilityName) : '', (opt_data.documentingPersonnelName) ? '<br>Documented by: ' + soy.$$escapeHtml(opt_data.documentingPersonnelName) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.reportFeeds.writeSeeMenu = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<ul class="el8WriteSeeMenuList">');
  var rTypeList5879 = opt_data.reportTypes;
  var rTypeListLen5879 = rTypeList5879.length;
  for (var rTypeIndex5879 = 0; rTypeIndex5879 < rTypeListLen5879; rTypeIndex5879++) {
    var rTypeData5879 = rTypeList5879[rTypeIndex5879];
    output.append('<li class="jump-to-report-feed-trigger" data-id="', soy.$$escapeHtml(rTypeData5879.id), '">', soy.$$escapeHtml(rTypeData5879.nickname), ' Reports</li>');
  }
  output.append('</ul>');
  if (!opt_sb) return output.toString();
};
